import { FilterTypeEnum } from '../enums';

export const urlByFilterType: Record<string, string> = {
  [FilterTypeEnum.BuildingUtilization]: '/office-utilization',
  [FilterTypeEnum.FloorUtilization]: '/floor-utilization',
};
